<template>
    <div class="w-100">
    <p class="next-action-desc v-center">
        Please choose the users to work on {{ selectedStartingStep.name ?? "the current step" }}
           <img
                v-if="!enableChildTenants"
                class="pointer ml-2"
                src="@/assets/images/icons/info-icon.svg"
                width="15"
                alt="info icon"
                v-tooltip="
                `You cannot add external collaborators to ${selectedStartingStep.name} because the ‘form create’ trigger is enabled`"
              />
    </p>
    <div class="flex v-center gap-2" ref='userSelectionContainer'>
        <component
        :ref="'multiuserFieldref'"
        :data="{caption: '', required: false, visibility:false}"
        :is="'MULTI_USER_COMPONENT'"
        mode="EDIT"
        :viewOnly="false"
        @customChange="handleUserSelection"
        :showOnlyActiveUsers="true"
        :selectedUserGroup="selectedUserGroup"
        :selectedUsers="selectedUsers"
        :enableChildTenants="enableChildTenants"
        />
    </div>
    </div>
</template>
<script>
import multiUserComponent from '@/components/form/elements/multiUserComponent.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'userSelectionForWf',
  components: {
    MULTI_USER_COMPONENT: multiUserComponent
  },
  props: {
    selectedStartingStep: {
      type: Object,
      default: () => ({})
    },
    selectedUsers: {
      type: Array,
      default: () => ([])
    },
    selectedUserGroup: {
      type: Array,
      default: () => ([])
    },
    enableChildTenants: {
      type: Boolean,
      default: true
    }

  },
  computed: {
    ...mapGetters(['isExternalCollaborator', 'collaboratorId'])
  },
  methods: {
    handleUserSelection (data) {
      this.$emit('handleUserSelection', data)
    },
    styleUserSelectionContainer () {
      const container = this.$refs.userSelectionContainer
      if (container) {
        const select = container?.getElementsByTagName('select')
        select[0].style.padding = ' 0 0.85em'
        select[0].style.height = '25px'
        select[0].style.fontSize = '.8rem'
        const textInput = container.querySelector('input[type="text"]')
        textInput.style.padding = '0 0.85em'
        textInput.style.height = '25px'
        textInput.style.fontSize = '.8rem'
        const badge = container.querySelectorAll('.form-user-bedge') ?? []
        badge.forEach((item) => {
          item.style.fontSize = '.8rem'
        })
      }
    }
  },
  mounted () {
    this.styleUserSelectionContainer()
  }
}

</script>
<style lang="scss" scoped>
.next-action-desc{
font-size: var(--text-xs2);
color: #666;
}
</style>
